import { render, staticRenderFns } from "./passengersInfo.vue?vue&type=template&id=6f6f584f&scoped=true"
import script from "./passengersInfo.vue?vue&type=script&lang=js"
export * from "./passengersInfo.vue?vue&type=script&lang=js"
import style0 from "./passengersInfo.vue?vue&type=style&index=0&id=6f6f584f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f584f",
  null
  
)

export default component.exports